import React from 'react';
import { FaFilePdf, FaHourglassHalf, FaDownload } from 'react-icons/fa';
import { DocumentRow, DocumentInfo, DocumentActions, FileInfo, AutoGeradoBadge, DownloadButton } from './styles';

// Baixa o File já gerado em memória (não passa por nenhuma API).
const baixarArquivo = (file) => {
  const url = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url;
  link.download = file.name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revogar na hora pode cancelar o download em alguns navegadores (Firefox/Safari)
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

// Item exibido pro documento gerado automaticamente (Resumo do Requerimento) —
// diferente de DocumentUploadItem, nunca tem botão de selecionar arquivo nem
// de remover: a pessoa só vê o resultado, já pronto e anexado, e pode baixá-lo.
const AutoGeneratedDocumentItem = ({ documento, file, pronto }) => (
  <DocumentRow>
    <DocumentInfo>
      <strong>
        {documento.name}
        <AutoGeradoBadge>Gerado automaticamente</AutoGeradoBadge>
      </strong>
      <small>{documento.description}</small>
    </DocumentInfo>
    {pronto ? (
      <DocumentActions>
        <FileInfo>
          <FaFilePdf color="#ef4444" />
          <span>{file?.name}</span>
        </FileInfo>
        {file && (
          <DownloadButton type="button" onClick={() => baixarArquivo(file)} title="Baixar o resumo em PDF">
            <FaDownload size={12} />
            Baixar
          </DownloadButton>
        )}
      </DocumentActions>
    ) : (
      <FileInfo>
        <FaHourglassHalf color="#64748b" />
        <span>Gerando resumo...</span>
      </FileInfo>
    )}
  </DocumentRow>
);

export default AutoGeneratedDocumentItem;
